import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from "../../../../common/variables/translate-service";
import { Store } from '@ngrx/store';
import { triggerPanel, triggerStatics } from '../../../../store/senAppProjects.action';
import { PanelAutofillArea } from "../../../../common/input/PanelAutofillArea";
import { SC_Input } from "../../../../common/input/SC_Input";
import { ModulProp } from "../../../../common/panel/ModulProp";
import { GlobalFunctionService } from '../../../../common/services/global-function.service';
import { DrawRoofForPanel } from '../../../../common/panel/drawRoofForPanel';
import { Modul } from '../../../../common/panel/Modul';
import genaratePanelSave from '../../../../common/panel/savePanelDetails';
import { Global } from "../../../../common/utilities/global";

@Component({
  selector: 'sen-app-roof-panel-select-box',
  templateUrl: './roof-panel-select-box.component.html',
  styleUrls: ['./roof-panel-select-box.component.scss']
})

export class RoofPanelSelectBoxComponent implements OnInit {
  defaultTab = 0;
  senPanelValid: boolean = false;
  ownPanelValid: boolean = false;
  panelDirectionValues = ModulProp;
  panelFillValues = PanelAutofillArea;
  //this needs to be implemented since some of panels should be layed landscape
  panelDirection: number;
  panelFill: number = SC_Input.iPnlFillArea;
  panelFillAll: boolean = Global.toggleBoundaryArea;
  sPanel: any;
  validateForm: boolean = false;
  projectModulname: string = SC_Input.projectModulname;

  constructor(public translate: TranslateService,
    private store: Store<any>,
    public globalF: GlobalFunctionService, @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RoofPanelSelectBoxComponent>) { }

  ngOnInit(): void {
    if (this.data.panelData) {
      if (!this.data.panelData.senItemID && this.data.projectData.roofPlans.length) {
        this.defaultTab = 1;
      }
      if (!this.defaultTab && this.data.panelData.senItemID && this.data.panelData?.landscape || this.defaultTab && !this.data.panelData.senItemID && this.data.panelData?.landscape) {
        this.panelDirection = this.panelDirectionValues.ORIENTATION_HORIZONTAL;
      } else {
        this.panelDirection = this.panelDirectionValues.ORIENTATION_VERTICAL;
      }
    }
  }

  triggerStatics() {
    this.store.dispatch(triggerStatics());
  }

  getSelectedPanel(event: any) {
    this.sPanel = event;
  }

  checkPanelOrientation() {
    if (!this.defaultTab && this.data.panelData.senItemID && this.data.panelData?.landscape) {
      return true;
    } else if (this.defaultTab && !this.data.panelData.senItemID && this.data.panelData?.landscape) {
      return true;
    }
    return false;
  }


  onOKClick() {
    this.validateForm = !this.validateForm;
    if ((!this.defaultTab && !this.senPanelValid) || (this.defaultTab && !this.ownPanelValid)) {
      return;
    }
    this.globalF.setPanel(this.sPanel);
    if (this.defaultTab) {
      SC_Input.bModSEN = false;
    } else {
      SC_Input.bModSEN = true;
    }
    SC_Input.iModAlignment = parseInt(this.panelDirection + '');
    SC_Input.iPnlFillArea = this.panelFill;
    Modul.clearAllPanels();
    this.closeDialogue();
    // setTimeout(() => {
    //   DrawRoofForPanel.drawModules();
    // }, 10);
    // setTimeout(() => {
    //   genaratePanelSave();
    // }, 1500);
  }

  closeDialogue() {
    this.store.dispatch(triggerPanel());
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
